export default __webpack_public_path__ + "static/media/red-face.fda890f8.png";